// Real data sourced from Amazon author page B08LV94L9S
// Author photo: customer-assets URL provided by user

export const AUTHOR_PHOTO = 'https://customer-assets.emergentagent.com/job_author-cristiano/artifacts/9ltkb9ji_Gemini_Generated_Image_od4bo1od4bo1od4b-clean.png';

export const AUTHOR_QUOTE =
  'Penido destaca-se como uma voz autêntica na literatura cristã contemporânea, onde sua escrita fluida e intensa transforma esperança em verdadeira arte. Um contador de histórias que ressoa profundamente na alma. Com uma prosa leve e verdadeira, ele narra a presença de Deus sem soar pregações, alcançando o coração do cético e oferecendo conforto ao fiel.';

export const series = [
  {
    slug: 'contos-que-falam-de-deus',
    title: 'Contos que Falam de Deus',
    tagline: 'Sete livros · Série Histórias de Anjos',
    description:
      'Sete volumes da série "Histórias de Anjos" — uma coleção que reúne narrativas breves sobre milagres cotidianos, fé e a presença silenciosa do divino. Histórias que se leem em poucas páginas e se carregam por muito tempo.',
    books: [
      {
        id: 'cfd-1',
        title: 'Histórias de Anjos I',
        synopsis: 'O início da série mais lida do autor. Contos sobre encontros inesperados com o sagrado.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-Cristiano-Penido-ebook/dp/B09L4JJY5R',
        cover: 'https://m.media-amazon.com/images/I/71-fqTd4iFL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-2',
        title: 'Histórias de Anjos II — Novos Milagres',
        synopsis: 'A continuação da série. Novos relatos de fé em meio ao cotidiano improvável.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3ria-anjos-II-milagres-Hist%C3%B3rias-ebook/dp/B08QHCQQ99',
        cover: 'https://m.media-amazon.com/images/I/81TVf7l089L._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-3',
        title: 'Histórias de Anjos III — O Poder da Oração',
        synopsis: 'Quando a oração se faz presença e a presença se faz milagre.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-III-poder-ora%C3%A7%C3%A3o-ebook/dp/B08T827X9V',
        cover: 'https://m.media-amazon.com/images/I/81T+iAs+PML._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-4',
        title: 'Histórias de Anjos IV — Falando com Deus',
        synopsis: 'Diálogos íntimos entre o humano e o divino, narrados em prosa leve.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-IV-Falando-Deus-ebook/dp/B08V5PMPBQ',
        cover: 'https://m.media-amazon.com/images/I/81iZ9WyreSL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-5',
        title: 'Histórias de Anjos V — Ele Quer Te Ouvir',
        synopsis: 'A escuta como gesto de amor. Contos sobre o Deus que aguarda nossas palavras.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-Ele-quer-ouvir-ebook/dp/B095NJLFWQ',
        cover: 'https://m.media-amazon.com/images/I/81l3anKYesL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-6',
        title: 'Histórias de Anjos VI — A Fé Move Montanhas',
        synopsis: 'Sete relatos sobre a fé que transforma o impossível em testemunho.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-VI-move-montanhas-ebook/dp/B096DPY2WV',
        cover: 'https://m.media-amazon.com/images/I/81e9gby3pML._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'cfd-7',
        title: 'Histórias de Anjos VII — Há Esperança',
        synopsis: 'O encerramento da série. Contos sobre o reencontro com a esperança em tempos difíceis.',
        amazonUrl: 'https://www.amazon.com.br/Hist%C3%B3rias-Anjos-VII-H%C3%A1-esperan%C3%A7a-ebook/dp/B09GLBJWZM',
        cover: 'https://m.media-amazon.com/images/I/81WywlA4vPL._AC_SY315_.jpg',
        published: true,
      },
    ],
  },
  {
    slug: 'historias-reais-de-fe',
    title: 'Histórias Reais de Fé',
    tagline: 'Quatro livros',
    description:
      'Romances baseados em histórias verdadeiras. Vidas reais que atravessaram a perda, o exílio interior e a reconciliação — testemunhos transformados em narrativa literária.',
    books: [
      {
        id: 'hrf-1',
        title: 'Regina — Saída das Cinzas',
        synopsis: 'Baseado em fatos reais. A trajetória de Regina, mulher que renasce de uma vida em ruínas.',
        amazonUrl: 'https://www.amazon.com.br/REGINA-Sa%C3%ADda-cinzas-Cristiano-Penido-ebook/dp/B0FL18H1TG',
        cover: 'https://m.media-amazon.com/images/I/81GNC3xnQbL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'hrf-2',
        title: 'O Trompetista que Falava com Deus',
        synopsis: 'Um músico, um dom e uma conversa com o sagrado que muda tudo. Inspirado em fatos reais.',
        amazonUrl: 'https://www.amazon.com.br/TROMPETISTA-QUE-FALAVA-COM-DEUS-ebook/dp/B0FNRQZV4W',
        cover: 'https://m.media-amazon.com/images/I/71aRl7eTzdL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'hrf-3',
        title: 'Fernando — O Filho Pródigo',
        synopsis: 'A jornada de Fernando: o desvio, a queda e o regresso. Uma releitura contemporânea da parábola do filho pródigo.',
        amazonUrl: 'https://www.amazon.com.br/FERNANDO-FILHO-PR%C3%93DIGO-Hist%C3%B3rias-Reais-ebook/dp/B0GTFGYSSL',
        cover: 'https://m.media-amazon.com/images/I/718yPnf+34L._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'hrf-4',
        title: 'Em desenvolvimento',
        synopsis: 'Novo título da série, atualmente em fase de escrita. Aguarde o lançamento.',
        amazonUrl: null,
        cover: null,
        published: false,
      },
    ],
  },
  {
    slug: 'ficcao-evangelica',
    title: 'Ficção Evangélica',
    tagline: 'Três livros',
    description:
      'Romances de imaginação ancorada nas escrituras. Personagens, épocas e dilemas que dialogam com a tradição cristã em chave literária.',
    books: [
      {
        id: 'fe-1',
        title: 'O Último Legionário — Guerras e Milagres',
        synopsis: 'Roma, século I. Um legionário descobre, entre batalhas e milagres, que a verdadeira conquista é interior. Próximo lançamento.',
        amazonUrl: null,
        cover: null,
        published: false,
      },
      {
        id: 'fe-2',
        title: 'O Evangelho Segundo Maria — O Início de Tudo',
        synopsis: 'Uma narrativa que imagina a vida de Maria antes do anúncio: a infância, a fé herdada, o silêncio que precede o Sim.',
        amazonUrl: 'https://www.amazon.com.br/evangelho-segundo-Maria-in%C3%ADcio-tudo-ebook/dp/B0CCLK27JF',
        cover: 'https://m.media-amazon.com/images/I/818D3XkFVTL._AC_SY315_.jpg',
        published: true,
      },
      {
        id: 'fe-3',
        title: 'O Convertido',
        synopsis: 'A história de uma conversão — não a do início, mas a que acontece quando tudo parecia perdido.',
        amazonUrl: 'https://www.amazon.com.br/convertido-Cristiano-Penido-ebook/dp/B0DCC7KKJW',
        cover: 'https://m.media-amazon.com/images/I/81h40O+qL2L._AC_SY315_.jpg',
        published: true,
      },
    ],
  },
  {
    slug: 'historias-nao-evangelicas',
    title: 'Histórias Não Evangélicas',
    tagline: 'Um livro',
    description:
      'O Cristiano Penido fora do registro espiritual: ficção, distopia, política e os labirintos do humano contemporâneo.',
    books: [
      {
        id: 'hne-1',
        title: 'Inverno Nuclear em Quebec',
        synopsis: 'Distopia ambiental num Quebec gélido após o colapso. Memória, sobrevivência e o que resta da humanidade quando o mundo se cala.',
        amazonUrl: 'https://www.amazon.com.br/Inverno-nuclear-Quebec-Cristiano-Penido-ebook/dp/B08LCNSVR1',
        cover: 'https://m.media-amazon.com/images/I/81dUu0s9bGL._AC_SY315_.jpg',
        published: true,
      },
    ],
  },
];

export const getSeriesBySlug = (slug) => series.find((s) => s.slug === slug);
export const totalBooks = series.reduce((acc, s) => acc + s.books.length, 0);

// Short stories — published in anthologies by Chiado Books & Flamingo Edições
export const shortStories = [
  {
    slug: 'entre-o-fogo-e-o-mar',
    title: 'Entre o Fogo e o Mar',
    publisher: 'Chiado Books',
    country: 'Portugal',
    anthology: 'Lisboa, uma cidade mágica',
    date: '14/04/2026',
    tagline: 'Romance, fé e o grande terremoto de Lisboa de 1755.',
    body: `Lisboa amanheceu dourada naquele primeiro de novembro de 1755. Os sinos das centenas de igrejas chamavam para a missa de Todos os Santos, e a capital do império parecia suspensa numa paz antiga. Inês caminhava com pressa pelo Chiado, o véu preso com descuido, o coração mais inquieto que o habitual.

Não era a liturgia que a apressava. Era ele.

Tomás esperava-a na penumbra de um beco. Filho de judeus, ele era uma presença proibida na vida de uma moça católica. O pai de Inês jurara matar o "infiel" que ousasse tocar na honra da família, e sua mãe mantinha Inês sob uma vigilância de ferro, moldada por sermões sobre castigo eterno e pureza de sangue. O amor deles era um crime contra a Igreja e contra a Coroa.

— Se nos virem, não haverá misericórdia — sussurrou Inês, ao sentir a mão de Tomás.

Ele não respondeu de imediato. Havia algo diferente no seu olhar — não apenas urgência, mas decisão.

— Comprei a passagem — disse, por fim.

Inês franziu o cenho.

— A passagem?

— Para o Brasil. Um navio parte amanhã. Gente como eu não tem futuro aqui.

O coração de Inês falhou um compasso.

— E tu vais?

— Vou — respondeu ele, firme. Depois, aproximou-se mais, como se o mundo inteiro pudesse ouvi-los. — Mas não quero ir sozinho.

O silêncio entre os dois pareceu maior do que a própria cidade.

— Vem comigo, Inês.

Ela recuou um passo, como se aquelas palavras fossem mais perigosas do que qualquer ameaça do pai.

— E minha família?

— A tua família será eu e os nossos filhos — disse ele, com uma certeza que não pedia permissão. — Quero ter muitos.

Inês baixou os olhos.

— Mas eles são tudo o que eu conheço.

Tomás segurou-lhe o rosto com cuidado.

— E o nosso amor? É questão de dias para o teu pai descobrir que nos encontramos às escondidas. E quando descobrir…

Não terminou a frase.

Não precisava.

Inês abriu a boca para responder, mas hesitou. Entre o medo e o desejo, entre o dever e a liberdade, o mundo pareceu suspenso por um instante.

E então… rugiu.

O chão tremeu sob seus pés. O que começou como um rumor profundo tornou-se um espasmo violento da terra. Fachadas de mármore, altares de ouro e casas senhoriais desmoronaram como se fossem feitas de pó.

Inês virou-se instintivamente para a direção de sua casa.

O palacete dos pais — símbolo de tudo o que a prendia — desapareceu numa nuvem de poeira sufocante.

Um grito morreu em sua garganta.

Por um instante impossível, pensou em correr para lá.

Mas o chão abriu-se mais uma vez, e Tomás puxou-a com força.

— Inês!

O mundo que exigia sua escolha estava a ruir antes que ela pudesse fazê-la.

— Temos de fugir! — gritou ele, arrastando-a antes que o fogo, nascido das velas da missa, engolisse o beco.

Correram para o Tejo, o único refúgio contra as chamas que devoravam a cidade. Atrás deles, Lisboa desfazia-se em gritos, poeira e colunas partidas.

Mas a natureza ainda não terminara.

O rio recuou.

Barcos tombaram sobre a lama exposta, peixes debatiam-se ao sol, e um silêncio estranho — quase sagrado — tomou conta do cais.

— Tomás… — murmurou Inês, sem compreender.

Ele não respondeu. Apenas a segurou com mais força.

A água voltou.

Não como rio, mas como muro.

A onda avançou sobre o Terreiro do Paço, varrendo o que restava da velha Lisboa — igrejas, casas, nomes, certezas.

Tomás agarrou Inês e prendeu-a a uma estrutura de madeira. A água tentou separá-los, arrancá-los um do outro, como se o mundo insistisse em concluir aquilo que os homens haviam começado.

Naquele instante, não havia Igreja, nem Coroa, nem pureza ou pecado.

Havia apenas dois corpos agarrados à vida — e um ao outro.

***

Quando o silêncio finalmente caiu sobre as ruínas, Lisboa era um cemitério de cinzas e sal.

Inês abriu os olhos.

Tomás estava ao seu lado, ferido, mas vivo.

Ela virou-se lentamente para o horizonte.

Onde antes havia ruas, igrejas e certezas, restava apenas vazio.

Não havia mais casa.

Não havia mais cidade.

Não havia mais o mundo que lhe exigia obediência.

A liberdade chegou como o fogo: devastando tudo primeiro.

— Eles morreram… — disse Inês, como se ainda não compreendesse as próprias palavras.

Tomás a envolveu nos braços, mas não havia consolo possível — apenas o peso de um mundo que já não existia.

Choraram não apenas pelos mortos, mas pelo que tinham sido até ali.

O vento trouxe o cheiro de cinza e mar.

Tomás olhou ao redor, para a cidade reduzida a ruínas.

Inês apertou-lhe a mão.

— E agora, Tomás… o que faremos?

O jovem apenas a abraçou e deixou que o silêncio respondesse por ele.

***

Séculos depois.

Num apartamento no Chiado, uma mulher fechava um diário de capa gasta. A filha, sentada ao seu lado, observava a cidade iluminada pela janela, bela e viva — como se nunca tivesse caído.

— E eles foram para o Brasil, mamãe? — perguntou a menina.

A mãe sorriu de leve, sem responder de imediato.

Seus olhos desviaram para uma pintura antiga na parede: um casal cercado por filhos e netos, os rostos marcados por um tempo distante.

— Algumas viagens não precisam de navio — disse, por fim.

A menina franziu a testa, mas não insistiu.

Encostou a cabeça no ombro da mãe.

Lá fora, a cidade continuava.

Entre o fogo e o mar, Lisboa aprendera a recomeçar.

E, em algum ponto do passado, dois nomes permaneciam — não pelo que perderam, mas pelo que ousaram escolher quando tudo mais era ruína.`,
  },
  {
    slug: 'o-computador',
    title: 'O Computador',
    publisher: 'Flamingo Edições',
    country: 'Portugal',
    anthology: 'Pequenas Histórias',
    date: '22/06/2026',
    tagline: 'Um menino, uma descoberta inesperada e uma pergunta que desafia o acaso.',
    body: `Alberto encontrou um objeto minúsculo na grama. Era oval, liso e tinha uma bordinha preta que parecia o encaixe de um carregador de celular.

— Uau! Um computador! — exclamou, guardando o achado na mochila.

Em casa, não achou botões ou parafusos. Para não estragar o aparelho, protegeu-o em uma caixinha de fósforos com algodão.

— Amanhã mostro para o professor. Ele saberá como ligar.

Mas Alberto se distraiu com os deveres da escola e esqueceu a caixinha na mochila. Duas semanas depois, lembrou-se de repente:

— Meu computador!

Ao abrir a mochila, percebeu que a caixinha estava úmida.

— Devo ter deixado molhar — pensou. — Estraguei meu computador.

Ao abrir a caixinha de fósforos, tomou um susto. A capa externa tinha se rompido e duas pequenas placas solares surgiram lá de dentro.

— Incrível! Está funcionando.

Animado, colocou-o perto da janela para receber mais luz e pingou mais algumas gotinhas de água. Nos dias seguintes, a máquina cresceu, ganhando novos cabos e coletores de energia. Logo, surgiram várias caixinhas compridas penduradas na estrutura. Pareciam cartuchos de memória e, dentro deles, havia vários computadores idênticos ao primeiro, novinhos em folha!

Alberto estava boquiaberto.

— Como aquela máquina se clonava daquele jeito? De onde tirava material para se autoconstruir? É muita tecnologia em algo tão pequeno.

Nesse instante, sua mãe entrou no quarto:

— Que lindo, filho! Vejo que o teu pé de feijão deu muitas sementes.

— Pé de feijão? — perguntou Alberto.

— Claro! Você plantou uma semente de feijão.

Alberto olhou para a planta, depois para as sementes em suas mãos. Por alguns instantes, permaneceu em silêncio, tentando compreender aquilo tudo. Então ergueu os olhos para a mãe e perguntou:

— É possível que uma tecnologia tão extraordinária seja apenas obra do acaso?`,
  },
  {
    slug: 'helena',
    title: 'Helena',
    publisher: 'Chiado Books',
    country: 'Portugal',
    anthology: 'Minha Mãe',
    date: '29/03/2025',
    tagline: 'Baseado em uma história real. Uma mãe, seis filhos e a sabedoria que se herda.',
    body: `Helena começava a cozinhar antes do amanhecer e só terminava ao anoitecer. Sem muito tempo para os seis filhos, eles cresciam soltos, aprendendo a se virar sozinhos.

Até o caçula encontrou seu caminho. Balançava o berço, movendo-o pelo quarto e avançando pelo corredor. Um dia, pulou do cercado e saiu correndo.

Helena estava na cozinha quando sentiu alguém abraçar suas pernas. Assustada, olhou para baixo. Lá estava ele, sorrindo, orgulhoso de sua conquista.

Ela se ajoelhou, envolveu-o nos braços e, entre lágrimas, disse:

— Oh, meu menino! Mamãe mal teve tempo para você, e agora já anda sozinho. Me perdoa, filho.

O pequeno a abraçou, batendo de leve no rosto dela, chamando-a para brincar. Helena secou as lágrimas, reduziu o fogo das panelas e, por um instante, se permitiu apenas ser mãe.

Apesar das lutas e brigas infindáveis com o esposo, aquela mulher guerreira tinha as bênçãos de Deus. Em tudo o que punha as mãos, o Senhor fazia prosperar e, junto com o marido, foram, gradativamente, saindo daquela crise financeira que parecia interminável.

Então, como um milagre, as brigas começaram a diminuir à medida que envelheciam juntos.

Os filhos cresceram, casaram-se e tiveram seus próprios filhos. Aos domingos, a casa agora se enchia de netos e bisnetos; a mesa já não comportava todos. Da cozinha, seu canto predileto, Helena viveu um momento mágico.

Lembrou-se da conversa com sua mãe, quase cinquenta anos atrás, quando queria se separar de João. A voz materna ecoou em sua memória, citando um provérbio bíblico:

— "A mulher sábia edifica sua casa; a tola a destrói com as próprias mãos". Qual delas você pretende ser, minha filha?

Helena olhou para o esposo, sorrindo entre os filhos e netos. Emocionada, sussurrou:

— Agora eu sei a resposta, Senhor. Glória ao Teu Santo Nome.`,
  },
  {
    slug: 'o-primeiro-beijo',
    title: 'O Primeiro Beijo',
    publisher: 'Chiado Books',
    country: 'Portugal',
    anthology: 'Três Quartos de Amor',
    date: '03/01/2025',
    tagline: 'A adolescência, a primeira namorada e o medo doce de não saber beijar.',
    body: `Aguardando na garagem do prédio, do alto dos seus quatorze anos, vestindo um short curto e muitas espinhas no rosto, Carlinhos não via a hora dela chegar, sua vizinha, ainda mais nova que ele.

A mocinha surgiu na porta do seu apartamento, alguns meses antes, à procura da sua irmã. Carlinhos a convidou a entrar.

— Ela não vai demorar. Senta aí um pouquinho.

— Obrigada — disse a donzela.

Carlinhos a olhou de cima a baixo e a achou meio desengonçada.

— Qual o teu nome? — perguntou, tentando puxar papo.

— O meu nome é Simone e o teu?

— Eu? O meu nome é Carlos — respondeu, sem saber mais o que dizer.

O silêncio tomou a sala e os dois ficaram ali, um olhando para a cara do outro, sem mais assunto. Vanessa, a irmã de Carlinhos, para alívio dos dois, entrou no ambiente e, com desenvoltura, já foi cumprimentando a nova amiga.

— Oi, Simone. Vem pra cá — apontou a moça em direção ao interior do apartamento, e as duas juntas foram para o quarto, fecharam a porta e de lá não saíram tão cedo.

Carlinhos voltou para o seu canto, pôs um disco do Supertramp, aumentou o som um pouco para impressionar a menina, fechou a porta e se deitou na cama pensando na prova de matemática que teria que fazer dali a alguns dias.

Aos poucos, Simone e Carlinhos começaram a se falar mais e uma vontade de se ver de novo foi só aumentando.

— Você sabe beijar de língua, Carlinhos? — perguntou Vanessa, sua irmã.

— Beijar de língua? O que é isso?

A jovem soltou a maior risada e, com seus quinze anos de sabedoria, respondeu:

— Você é ainda muito criança.

O rapaz ficou preocupadíssimo. Mal sabia o mancebo que ela também não tinha a menor ideia do que era beijar assim.

— Me conta como é beijar de língua.

— É muito simples... — começou a explicar a especialista, dando uma descrição técnica do assunto.

Carlinhos não disse mais nada. Ficou imaginando o que aquilo significava e desejou logo ascender ao seleto mundo dos homens que sabiam beijar.

Era o primeiro encontro oficial dos dois. Eles ficariam sozinhos, no canto da garagem, perto do Corcel 1970 do seu pai. Não demorou, ela apareceu. Os óculos dele começaram a embaçar. A donzela se sentou sobre o capô do carro e os dois ficaram mais próximos que o normal. Ela gostava de falar muito, mas neste dia, estava super calada. Carlinhos olhava para aquela menina, que agora estava linda. Cabelos pretos, olhos castanhos claros e aquela boca repleta de batom vermelho da marca Boca Louca.

Sem muito jeito com as mulheres, ele foi logo dizendo:

— Você quer namorar comigo?

Simone respondeu quase tão rápido quanto ele perguntou.

— Quero.

— Então me dá um beijo.

A jovem corou na hora.

— Te beijar?

— É, beijar. Agora nós somos namorados.

A menina não sabia o que dizer. Tentou desconversar e, por fim, pulou do capô e saiu correndo.

— Eu te vejo amanhã.

O beijo de língua teria que esperar.`,
  },
  {
    slug: 'o-companheiro',
    title: 'O Companheiro',
    publisher: 'Chiado Books',
    country: 'Portugal',
    anthology: 'Contos de Natal',
    date: '30/09/2024',
    tagline: 'Uma viúva, um menino e um Natal que mudou duas vidas.',
    body: `Faltavam três dias para o Natal e já haviam se passado três anos desde a morte do marido de Elza, mas ela ainda sentia sua ausência. O frio de dezembro intensificava o vazio deixado por ele. Elza mantinha o quarto dele intacto, como se ele fosse voltar.

A solidão era sua companheira constante, junto com a velha televisão e os antidepressivos cada vez mais fortes. Naquela tarde, Elza resolveu fazer algo que não fazia desde a morte do marido: ajoelhou-se e conversou com Deus, pedindo ajuda.

Ao entardecer, a campainha tocou. Elza abriu a porta e encontrou um menino maltrapilho e sujo, que perguntou se ela tinha pão velho. Sentindo algo diferente, Elza respondeu que tinha pão novo e o convidou a entrar.

Enquanto assava os pães, pediu que o menino lavasse as mãos. Ao ajudá-lo, notou as marcas de uma vida dura. "Qual o seu nome?" perguntou. "Ganso", respondeu ele com um sorriso tímido. Elza sorriu de volta e o convidou para a mesa.

Enquanto o menino comia, o coração de Elza se abriu. A bondade de oferecer comida e acolhimento trouxe uma luz que ela não sentia há tempos. Ganso agradeceu e, ao final da refeição, se despediu e foi embora.

De madrugada, Elza acordou com a chuva forte. Ao fechar a janela, viu Ganso tentando se proteger da tempestade. Pensou em voltar para a cama, mas uma força maior a impeliu a acolher o garoto em sua casa.

Após um banho e roupas limpas, Elza conduziu o jovenzinho ao quarto do marido, sentindo nostalgia e alegria por preencher aquele espaço vazio com vida novamente.

Na manhã seguinte, Elza encontrou Ganso lavando a louça. "Pra retribuir, dona Elza", disse ele com seu sorriso de criança. Algo dentro dela se aqueceu ainda mais.

Eles passaram o dia juntos e, a pedido da senhora, Ganso ficou todo o final de semana. Parecia que já se conheciam há anos, tamanha a interação que sentiam um com o outro. Contudo, ao final da tarde de domingo, Ganso se despediu. Elza, sem saber o que dizer, deixou-o partir.

Ao fechar a porta, uma tristeza a tomou. Vendo a televisão a sua frente, percebeu que não a havia ligado e nem sentira a necessidade de tomar os remédios há três dias. "Oh meu Deus. O que eu fiz? Deixei aquele anjo ir embora." Sem hesitar, correu atrás do menino. "Ganso, volte. Você quer passar o Natal comigo?" O menino, sorrindo, correu e a abraçou. "Quero sim, dona Elza."

Naquela noite de Natal, nem Elza nem Ganso sentiram tristeza ou solidão. Sentiram gratidão pelo presente inesperado que Deus lhes havia preparado. Ao final das festas, o menino foi ficando e, quando menos perceberam, haviam se tornado uma família.`,
  },
];

export const getStoryBySlug = (slug) => shortStories.find((s) => s.slug === slug);
